// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./reducers/auth";
import filters from "./reducers/filters";

const rootReducer = combineReducers({
  auth,
  filters,
});

export default rootReducer;
